import {Moon, Sun} from 'lucide-react';
import {Button} from '@/components/ui/Button';
import {useThemeStore} from '@/stores/themeStore';

export function ThemeToggle() {
  const theme = useThemeStore(s => s.theme);
  const toggle = useThemeStore(s => s.toggle);

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      aria-label="Toggle theme"
    >
      {theme === 'dark' ? (
        <Sun className="h-4 w-4" />
      ) : (
        <Moon className="h-4 w-4" />
      )}
    </Button>
  );
}
